export const overlayStyling = {
  display: 'flex',
  justifyContent: 'center',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100%',
  alignItems: 'center',
  zIndex: '1',
}

export const AddAccessModal = {
  display: 'flex',
  height: '100%',
  '.add-access-modal-left': {
    flex: '70%',
    backgroundColor: '#f5f8fa',

    '.modal-sub-header': {
      backgroundColor: '#fff',
      padding: '24px',
      overflow: 'auto',
      maxHeight: '200px',

      '.MuiBox-root': {
        marginTop: '0',
      },

      'h3': {
        padding: '0px',
        width: '32%',
        float: 'left',
      }
    },

    '.modal-list-wrapper': {
      padding: '24px',
    }
  },
  '.add-access-modal-right': {
    flex: '30%',
    padding: '24px',
    borderLeft: '1px solid rgba(0, 0, 0, 0.12)',

    '.access-group-BU': {
      marginTop: '15px'
    },

    '.access-group-dimension-label': {
      color:'#677074',
      lineHeight:'1.4375em',
      fontSize: '0.875rem',
      fontWeight: '500',
      marginBottom: '5px',
    },

    '.access-group-dimension-input': {
      border: '1px solid grey',
      borderRadius: '4px',
      minHeight:'42px',
      width: '100%'
    },
  },
  '.add-employee-wrapper': {
    float: 'right',

    '.MuiAutocomplete-root': {
      float: 'left', 
      width: '310px',
      padding: '1px',

      '.MuiChip-root': {
        height: '27px',
      },

      '.MuiOutlinedInput-root': {
        padding: '1px',
        background: 'rgb(242, 242, 242)',
        maxHeight: '200px',
        overflow: 'hidden',

        '.MuiInputBase-input': {
          minWidth: '15px',
        },

        '.MuiChip-root': {
          maxWidth: 'calc(100% - 60px)'
        },
      }
    },

    '.add-employee-button': {
      float: 'right',
    }
  },

  '.add-employee-label': {
    float: 'left',
    position: 'relative',
    lineHeight: '22px',
    top: '10px',
    marginRight: '10px',
    'div': {
      float: 'right',
      marginLeft: '8px',
    }
  }
}